import { render, staticRenderFns } from "./ShowBlockedSimCard.vue?vue&type=template&id=10c24a42&scoped=true"
import script from "./ShowBlockedSimCard.vue?vue&type=script&lang=js"
export * from "./ShowBlockedSimCard.vue?vue&type=script&lang=js"
import style0 from "./ShowBlockedSimCard.vue?vue&type=style&index=0&id=10c24a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c24a42",
  null
  
)

export default component.exports